module.exports = __webpack_public_path__ + "img/united-states.c7ef7aee.png";